import dayjs from "dayjs";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import { CUSTOMER_MULTI_SELECT_ACTIONS } from "@/features/chart-of-account-preferences";
import { apiClient, getErrorMessage } from "../../shared";
import { useSnackbar } from "../../ui";
import { CustomerFormDialog } from "../customer-form-dialog";

import { Button } from "@mui/material";

export const EditCustomerFormDialog = ({
  onClose,
  customerId,
  onSubmitted,
}) => {
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [defaultValues, setDefaultValues] = useState(null);

  useEffect(() => {
    const fetchCustomer = async () => {
      setIsLoading(true);
      try {
        const {
          data: {
            data: {
              name,
              gender,
              dateOfBirth,
              email,
              phoneNumbers,
              accountingActionChartOfAccounts,
            },
          },
        } = await apiClient.get(`customers/${customerId}`, {
          params: { withAccountingActionChartOfAccounts: true },
        });

        setDefaultValues({
          name,
          gender: gender ?? "",
          dateOfBirth: dateOfBirth ? dayjs(dateOfBirth) : null,
          email,
          phoneNumbers,
          accountingActionChartOfAccounts: (
            accountingActionChartOfAccounts ?? []
          ).reduce((acc, item) => {
            if (!item.chartOfAccount) return acc;
            if (CUSTOMER_MULTI_SELECT_ACTIONS.has(item.action)) {
              (acc[item.action] ??= []).push(item.chartOfAccount);
            } else {
              acc[item.action] = item.chartOfAccount;
            }
            return acc;
          }, {}),
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchCustomer();
  }, [customerId]);

  const handleSubmit = async ({
    name,
    gender,
    dateOfBirth,
    email,
    phoneNumbers,
    accountingActionChartOfAccounts,
  }) => {
    try {
      await apiClient.put(`customers/${customerId}`, {
        name,
        gender,
        dateOfBirth,
        email,
        phoneNumbers,
        accountingActionChartOfAccounts,
      });

      onSubmitted();
      onClose();
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal memperbarui pelanggan"));

      throw error;
    }
  };

  return (
    <CustomerFormDialog
      onClose={onClose}
      dialogTitle="Ubah Pelanggan"
      isLoading={isLoading}
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      renderDialogActionsChildren={({ isLoading }) => (
        <Button loading={isLoading} variant="contained" type="submit">
          Simpan
        </Button>
      )}
    />
  );
};

EditCustomerFormDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmitted: PropTypes.func.isRequired,
  customerId: PropTypes.string,
};
